import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button } from "antd";
import _ from "i18n";

import { setCollaboratorRegimes, initCapacityPlaningProduction } from "Actions";
import {
  deleteCollaboratorRegime,
  saveCollaboratorRegime,
  fetchCollaboratorSettingSuggestions
} from "Thunks";

import {
  onSuccess,
  onError,
  getDatesBetweenDates,
  getCountOpenDays
} from "Utils";
import { DIALOG_TYPES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import { SettingIcon, SvgIcon, ICONS, GarbageIcon } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";

import styles from "./RegimeSettingContent.local.scss";
import CheckBoxBtn from "../Common/Checkbox/CheckBoxBtn";
import moment from "moment";

class RegimeSettingContent extends Component {
  // **** RegimeSettingContent (functions) ***** //
  constructor(props) {
    super(props);
    this.state = {
      idRegime: null,
      regime: {
        id: null,
        hrNF: "",
        hrF: "",
        label: "",
        isFreelancer: false,
        hrForWeek: "",
        nbrOfWeeks: ""
      },
      disabledSave: true,
      deleteRegimeIsVisible: false
    };
  }

  handleDisplayDeleteRegime = id => {
    this.setState({
      idRegime: id,
      deleteRegimeIsVisible: true
    });
  };

  handleDeleteRegime = () => {
    const { settingSuggestions } = this.props;
    let updatedRegimes = settingSuggestions.data.regimes;
    let { idRegime } = this.state;
    this.setState({ loading: true });

    this.props.dispatch(deleteCollaboratorRegime(idRegime)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("regimeDeleted")
        });
        this.props.dispatch(
          setCollaboratorRegimes(
            updatedRegimes.filter(({ id }) => id !== idRegime)
          )
        );
        this.props.dispatch(initCapacityPlaningProduction());
        this.cancelDeleteRegime();
      },
      err => {
        this.cancelDeleteRegime();
        this.setState({ loading: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  cancelDeleteRegime = () => {
    this.setState({
      idRegime: null,
      deleteRegimeIsVisible: false
    });
  };

  handlePrepareUpdateRegime = regimeToUpdate => {
    this.setState({ regime: regimeToUpdate });
  };

  handleChangeRegimeLabel = event => {
    this.setState({
      regime: { ...this.state.regime, label: event.target.value },
      disabledSave: false
    });
  };

  handleChangeRegimeFreelancer = event => {
    this.setState({
      regime: {
        ...this.state.regime,
        isFreelancer: !this.state.regime.isFreelancer
      },
      disabledSave: false
    });
  };

  handleChangeRegimeRhHebdo = event => {
    this.setState({
      regime: { ...this.state.regime, hrForWeek: event.target.value },
      disabledSave: false
    });
  };

  handleChangeRegimeHNF = event => {
    this.setState({
      regime: { ...this.state.regime, hrNF: event.target.value },
      disabledSave: false
    });
  };

  handleChangeRegimeHF = event => {
    this.setState({
      regime: { ...this.state.regime, hrF: event.target.value },
      disabledSave: false
    });
  };

  handleChangeRegimeNbrWeeks = event => {
    this.setState({
      regime: { ...this.state.regime, nbrOfWeeks: event.target.value },
      disabledSave: false
    });
  };

  cancelUpdateRegime = () => {
    this.setState({
      regime: {
        id: null,
        label: "",
        hrNF: "",
        hrF: "",
        isFreelancer: false,
        hrForWeek: "",
        nbrOfWeeks: ""
      },
      disabledSave: true
    });
  };

  handleSaveRegime = () => {
    const { regime } = this.state;
    const { dispatch, collaboratorData } = this.props;
    let hours = parseInt(regime.hrForWeek / 5, 10);
    let minutes = Math.round(
      (regime.hrForWeek / 5 - parseInt(regime.hrForWeek / 5, 10)) * 60
    );
    let hrForDay = regime.label.includes("plein")
      ? hours + "." + (minutes.length < 1 ? "0" : "") + minutes
      : "";

    if (regime.label.includes("plein")) {
      collaboratorData.forEach(item => {
        if (item.regime === regime.id) {
          item.workingHours.monday = hrForDay;
          item.workingHours.tuesday = hrForDay;
          item.workingHours.wednesday = hrForDay;
          item.workingHours.thursday = hrForDay;
          item.workingHours.friday = hrForDay;
        }
      });
    }
    // TODO Check if all fields are assigned.

    dispatch(saveCollaboratorRegime(regime, hrForDay)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: regime.id ? _("regimeUpdated") : _("regimeCreated")
        });

        dispatch(fetchCollaboratorSettingSuggestions());
        dispatch(initCapacityPlaningProduction());
        this.setState({
          disabledSave: true,
          regime: {
            id: null,
            label: "",
            hrNF: "",
            hrF: "",
            hrForWeek: "",
            nbrOfWeeks: ""
          }
        });
      },
      err => {
        onError(
          err.response.data.errors
            ? err.response.data.errors[0].message
            : _("error")
        );
      }
    );
  };

  render() {
    const { settingSuggestions } = this.props;
    const { regime } = this.state;
    let year = moment().year();

    let dates = getDatesBetweenDates(
      new Date(year + "-01-01"),
      new Date(year + "-12-31")
    );
    let countOpenDays = getCountOpenDays(dates);

    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SettingIcon fill="#2495E1" size="20" />
            </div>
            <div className="upload-modal__header-title">{_("regimesList")}</div>
          </div>
          <div className={styles.modal_content}>
            <div
              className={classnames(
                "columns medium-5 small-5",
                styles.form_frame
              )}
            >
              <h3>{_(regime.id ? "updateRegime" : "createRegime")}</h3>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.input_div
                )}
              >
                <span>{_("title")}</span>
                <input
                  type={"text"}
                  value={regime.label}
                  onChange={event => this.handleChangeRegimeLabel(event)}
                />
              </div>
              <div className={styles.checkbox} style={{ marginTop: "1px" }}>
                <div>
                  <CheckBoxBtn
                    id="select-all"
                    checked={!regime.isFreelancer}
                    onChange={() => this.handleChangeRegimeFreelancer()}
                  />
                </div>
                <div className={styles.label}>salarié</div>
              </div>
              <div>
                <div className={styles.checkbox} style={{ marginTop: "1px" }}>
                  <CheckBoxBtn
                    id="select-allYT"
                    checked={regime.isFreelancer}
                    onChange={() => this.handleChangeRegimeFreelancer()}
                  />
                </div>
                <div className={styles.label}>freelancer</div>
              </div>
              <hr />
              <div className="row">
                <div
                  className={classnames(
                    "columns medium-4 small-4",
                    styles.input_div
                  )}
                >
                  {/* {!regime.isFreelancer ? ( */}
                  <span> {_("hrForWeek")}</span>
                  {/* ) : (
                  <span> {_("hrForYear")}</span>
                  )} */}
                  <input
                    type={"number"}
                    value={regime.hrForWeek}
                    onChange={event => this.handleChangeRegimeRhHebdo(event)}
                  />
                  {/* {regime.isFreelancer && (
                    <span>
                      {Math.floor(
                        (regime.hrForWeek * 60) / countOpenDays / 60
                      ) +
                        "." +
                        parseInt(
                          ((regime.hrForWeek * 60) / countOpenDays) % 60,
                          10
                        )}{" "}
                      h/j
                    </span>
                  )} */}
                </div>
              </div>
              <div className="row">
                <div
                  className={classnames(
                    "columns medium-4 small-4",
                    styles.input_div
                  )}
                >
                  <span>{_("basicFH")}</span>
                  <input
                    type={"number"}
                    value={regime.hrF}
                    onChange={event => this.handleChangeRegimeHF(event)}
                  />
                </div>
                <div
                  className={classnames(
                    "columns medium-4 small-4",
                    styles.input_div
                  )}
                >
                  <span>{_("basicNFH")}</span>
                  <input
                    type={"number"}
                    value={regime.hrNF}
                    onChange={event => this.handleChangeRegimeHNF(event)}
                  />
                </div>
                <div
                  className={classnames(
                    "columns medium-4 small-4",
                    styles.input_div
                  )}
                >
                  <span>{_("annualH")}</span>
                  <input
                    type={"number"}
                    value={parseInt(regime.hrNF) + parseInt(regime.hrF)}
                    disabled
                  />
                </div>
              </div>
              <div>
                <button
                  type={"success"}
                  className={styles.save_button}
                  disabled={this.state.disabledSave}
                  onClick={this.handleSaveRegime}
                >
                  <img
                    src={"/img/icons/tail-spin.svg"}
                    alt={""}
                    className={settingSuggestions.saving ? styles.loading : ""}
                  />
                  {_("save")}
                </button>
                {regime.id && (
                  <Button
                    type={"success"}
                    style={{
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: 14,
                      height: 37,
                      margin: "18px 3px 0px",
                      background: "transparent",
                      float: "left",
                      textTransform: "uppercase",
                      color: "#6D7F92"
                    }}
                    onClick={() => this.cancelUpdateRegime()}
                  >
                    {_("cancel")}
                  </Button>
                )}
              </div>
            </div>
            <div
              className={classnames(
                "columns medium-6 small-6",
                styles.list_frame
              )}
            >
              <h3>
                {_("regimesList")} ({settingSuggestions.data.regimes.length})
              </h3>
              <div className={`${styles.list_items} ${styles.list_regimes}`}>
                {settingSuggestions.fetching ? (
                  <div className={styles.ripple_loading}>
                    <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                  </div>
                ) : (
                  settingSuggestions.data.regimes &&
                  settingSuggestions.data.regimes.map(regime => {
                    return (
                      <div key={regime.id} className={styles.item}>
                        <span>{regime.label}</span>
                        <div
                          className={styles.actions}
                          onClick={event => {
                            event.stopPropagation();
                          }}
                        >
                          <div>
                            <span
                              className={`${styles.action} ${
                                styles.action_edit
                              }`}
                              onClick={() =>
                                this.handlePrepareUpdateRegime(regime)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.PENCIL}
                                className={styles.edit}
                              />
                            </span>
                            <span
                              className={`${styles.action} ${
                                styles.action_delete
                              }`}
                              onClick={() =>
                                this.handleDisplayDeleteRegime(regime.id)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.Garbage}
                                className={styles.delete}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={this.state.deleteRegimeIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteRegime,
            abortAction: this.cancelDeleteRegime,
            message: _("confirmationDeleteRegimeMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: "yes",
            abortBtnLabel: "no",
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteRegimeTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settingSuggestions: state.collaborator.settingSuggestions
});

export default connect(mapStateToProps)(RegimeSettingContent);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/RegimeSettingContent.js